import vars from './vars';

const saveButtonTheme = {
  containerStyle: {
    minWidth: 50,
    minHeight: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 20,
    // paddingLeft: 19,
    // paddingRight: 19,
    //backgroundColor: vars.colors.secondary.color2,
    backgroundColor: 'transparent',
    paddingLeft: 10,
    paddingRight: 10,
  },

  labelStyle: {
    ...vars.headings.h7,
    color: vars.colors.white,
  },
};

const cancelButtonTheme = {
  containerStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  labelStyle: {
    ...vars.headings.h7,
    //color: vars.colors.secondary.color2,
    color: 'black',
  },
};

export { saveButtonTheme, cancelButtonTheme };
